import { useEffect } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Card, Typography } from 'antd';
import { differenceInCalendarDays } from 'date-fns';

import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { subscriptionSelectors } from '@/core/redux/slices/subscription/selectors';
import { subscriptionActions } from '@/core/redux/slices/subscription/slice';
import { usersSelectors } from '@/core/redux/slices/users/selectors';
import { declination } from '@/helpers/converter';

import { CardComponent } from './CardComponent';
import { SubscriptionInfo } from './SubscriptionInfo';

const { Text, Title } = Typography;

export const Subscription: React.FC<any> = () => {
  const user = useAppSelector(usersSelectors.user);
  const subscriptionsList = useAppSelector(
    subscriptionSelectors.subscriptionsList
  );

  const { payment_status, plan_type, ends_at } = user?.subscription || {
    ends_at: '',
  };

  // Получаем оставшееся кол-во дней в подписке
  const count_days = differenceInCalendarDays(new Date(ends_at), new Date());
  const org_count_days = user?.organization_subscription_ends_at
    ? differenceInCalendarDays(
        new Date(user?.organization_subscription_ends_at),
        new Date()
      )
    : 0;

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(subscriptionActions.fetchSubscriptionsList());

    return () => {
      dispatch(subscriptionActions.setSubscriptionsList(null));
    };
  }, []);

  return (
    <div className='bg-white'>
      <div className='py-6 px-32 flex flex-col gap-4'>
        {(count_days >= 0 &&
          payment_status === 'succeeded' &&
          plan_type !== 'trial') ||
        (user?.organization_id && org_count_days > 0) ? (
          <SubscriptionInfo />
        ) : (
          <>
            <Card
              title={
                <div className='py-3'>
                  <div className='flex justify-between'>
                    <Title level={4}>Пробный доступ</Title>
                    {plan_type === 'trial' && (
                      <div className='flex items-center gap-2  bg-[#D9F7BE] border-[#389E0D] rounded-lg py-[4px] px-[16px] border border-1 border-gray-400 text-[14px]'>
                        <CheckOutlined />
                        Активен, осталось{' '}
                        {count_days >= 0
                          ? declination('day', count_days)
                          : '0 дней'}
                      </div>
                    )}
                  </div>
                  <div className='flex flex-col gap-4'>
                    <Text type='secondary' className='text-wrap'>
                      Пробный доступ на 14 дней к тарифу «Профессионал»
                    </Text>

                    <Text type='secondary' className='text-wrap'>
                      Вам доступен полный функционал тарифа «Профессионал». Это
                      лучшее время, чтобы оценить все инструменты, которые
                      экономят ваше время и повышают точность проектных решений.
                    </Text>
                  </div>
                </div>
              }
            >
              <div className='flex flex-col gap-4'>
                <Text className='font-semibold' style={{ fontSize: '20px' }}>
                  Что мы рекомендуем попробовать в первую очередь:
                </Text>
                <div>
                  <div className='flex gap-2'>
                    <span>•</span>{' '}
                    <span>
                      Свяжите вашу BIM-модель в Renga с нашими расчетами
                      аэродинамики и воздухообмена.
                    </span>
                  </div>
                  <div className='flex gap-2'>
                    <span>•</span>
                    <span>
                      Задайте сложный вопрос по проекту через приоритетный чат.
                    </span>
                  </div>
                  <div className='flex gap-2'>
                    <span>•</span>
                    <span>
                      Запросите ТКП на подбор оборудования для вашего проекта.
                    </span>
                  </div>
                </div>
              </div>
            </Card>

            {subscriptionsList?.map((subscription: any) => (
              <CardComponent
                key={subscription?.type}
                subscription={subscription}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
